import DateField from 'components/StraightThroughHouseholdComp/CustomInputs/DateField/DateField';
import { RadioButtonField } from 'components/StraightThroughHouseholdComp/CustomInputs/RadioButtonField/RadioButtonField';
import SelectDropdown from 'components/StraightThroughHouseholdComp/CustomInputs/SelectDropdown/SelectDropdown';
import dlStatus from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/DLStatus';
import gender from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/Gender';
import insuranceType from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/InsuranceType';
import relationship from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/Relationship';
import states from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/States';
import TextField from 'components/StraightThroughHouseholdComp/CustomInputs/TextField/TextField';
import { useDriverHHM } from 'components/StraightThroughHouseholdComp/HouseholdContext/DriverHHMContext';
import { HouseholdChangeContext } from 'components/StraightThroughHouseholdComp/HouseholdContext/HouseholdChangeContext';
import HelpfulDocumentsNJ from 'components/StraightThroughVehicleComp/1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/HelpfulDocumentsNJ/HelpfulDocumentsNJ';
import HelpfulDocumentsPA from 'components/StraightThroughVehicleComp/1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/HelpfulDocumentsPA/HelpfulDocumentsPA';
import { useContext, useState } from 'react';

const AddHhmForm = ({ context, changeClass }) => {
  const driverContext = useDriverHHM();
  const { driverHHM, driverHHMCallback, calculateAge } = driverContext;
  const blPipOption = [4, 5, 6].includes(context?.userData?.pipOption);
  const blIsRelative = ['Spouse', 'Child', 'Parent', 'Other Relative'].includes(driverHHM?.driverInfo?.relationshipToPolicyholder);
  const blHasInsurance = driverHHM?.driverInfo?.hasInsurance === '1';
  const blDriverAge = calculateAge(driverHHM?.userInfo?.dobMonth, driverHHM?.userInfo?.dobDay, driverHHM?.userInfo?.dobYear) >= 16;
  const blSameHousehold = driverHHM?.addressInfo?.sameHousehold === '1';
  const blIsMichigan = context?.userData?.state == 'Michigan';
  const blIsNewJersey = context?.userData?.state == 'New Jersey';
  const blIsPennsylvania = context?.userData?.state == 'Pennsylvania';
  const blUniversityAge = calculateAge(driverHHM?.userInfo?.dobMonth, driverHHM?.userInfo?.dobDay, driverHHM?.userInfo?.dobYear) <= 24;
  const blIsDriver =
    (driverHHM?.driverInfo?.licenseStatus == 'Valid' ||
      driverHHM?.driverInfo?.licenseStatus == 'Valid Pennsylvania License') &&
    driverHHM?.driverInfo?.ownInsurance === "0";
  const memberType = blIsDriver ? 'driver' : 'household member';
  const [requestedEffDate, setRequestedEffDate] = useState();

  return (
    <>
      <h5 className='text-primary text-center fw-bold my-3'>ADD HOUSEHOLD MEMBER</h5>

      <div style={{margin:"0px 0.5rem", padding: "0px 0.75rem"}}>
        {context?.addressChangeClass?.requestType !== "Address Change" &&
          <DateField
            label="Requested Effective Date*"
            dateSubmit={driverHHM?.requestedEffDate ? driverHHM?.requestedEffDate : requestedEffDate}
            setDateSubmit={setRequestedEffDate}
            storeValue={driverHHMCallback}
            nameValue="requestedEffDate"
            infoKey="requestedEffDate"
          />
        }

        {/* Full Name */}
        <TextField
          label={'Full Name*'}
          nameField={true}
          name={'fullName'}
          infoKey='userInfo'
          setCallback={driverHHMCallback}
          nameValues={{ firstName: driverHHM?.userInfo?.firstName, middleInitial: driverHHM?.userInfo?.middleInitial, lastName: driverHHM?.userInfo?.lastName }}
        />

        {/* Date of Birth */}
        <SelectDropdown
          label={'Date of Birth*'}
          infoKey={'userInfo'}
          dobField={true}
          setCallback={driverHHMCallback}
          hhmSet={true}
          dobValues={{ dobMonth: driverHHM?.userInfo?.dobMonth, dobDay: driverHHM?.userInfo?.dobDay, dobYear: driverHHM?.userInfo?.dobYear }}
        />

        {/* Gender */}
        <SelectDropdown
          label={'Gender*'}
          infoKey={'userInfo'}
          name={'gender'}
          value={driverHHM?.userInfo?.gender}
          dropdown={gender(context?.userData?.state)}
          setCallback={driverHHMCallback}
        />

        {/* Relationship */}
        <SelectDropdown
          label={`Relationship to policyholder (${context?.userData?.firstName})*`}
          name={'relationshipToPolicyholder'}
          infoKey='userInfo'
          value={driverHHM?.userInfo?.relationshipToPolicyholder}
          dropdown={relationship}
          setCallback={driverHHMCallback}
        />

        {/* Health Insurance */}
        {blIsRelative && blIsMichigan && (
          <>
            <RadioButtonField
              question={'Does this household member have health insurance?*'}
              name={'hasInsurance'}
              infoKey='driverInfo'
              value={driverHHM?.driverInfo?.hasInsurance || ''}
              setCallback={driverHHMCallback}
            />
            {driverHHM?.addressInfo?.hasInsurance === '1' && (
              <SelectDropdown
                label={'Please confirm what type of health insurance this household member has.*'}
                name={'insuranceType'}
                infoKey='driverInfo'
                value={driverHHM?.driverInfo?.insuranceType}
                dropdown={insuranceType}
                setCallback={driverHHMCallback}
              />
            )}
          </>
        )}
        {/* Same Household */}
        <RadioButtonField
          question={'Resides in same household*'}
          name={'sameHousehold'}
          infoKey='addressInfo'
          value={driverHHM?.addressInfo?.sameHousehold || ''}
          setCallback={driverHHMCallback}
        />
        {blDriverAge && (
          <>
            {/* Current License Status */}
            <SelectDropdown
              label={blIsMichigan ? 'Current License Status*' : 'What is the current status of this driver’s license?*'}
              name={'licenseStatus'}
              infoKey='driverInfo'
              value={driverHHM?.driverInfo?.licenseStatus}
              dropdown={dlStatus(context?.userData?.state)}
              setCallback={driverHHMCallback}
            />

            {driverContext?.driverHHM?.driverInfo?.licenseStatus &&
              <>
                {/* Age Licensed */}
                <TextField
                  label={"Age Licensed*"}
                  name={"licenseAge"}
                  infoKey='driverInfo'
                  value={driverContext?.driverHHM?.driverInfo?.licenseAge}
                  setCallback={driverContext?.driverHHMCallback}
                />
              </>}

            <>
              {/* License State */}
              <SelectDropdown
                label={'License State*'}
                name={'licenseState'}
                infoKey='driverInfo'
                value={driverHHM?.driverInfo?.licenseState || context?.userData?.state}
                dropdown={states}
                setCallback={driverHHMCallback}
              />

              {/* License Number */}
              <TextField
                label={'License Number*'}
                name={'licenseNumber'}
                infoKey='driverInfo'
                value={driverHHM?.driverInfo?.licenseNumber || ""}
                setCallback={driverHHMCallback}
              />

              {/* Own Insurance */}
              <RadioButtonField
                question={'Does this household member maintain his/her own auto insurance?*'}
                name={'ownInsurance'}
                infoKey='driverInfo'
                value={driverHHM?.driverInfo?.ownInsurance}
                setCallback={driverHHMCallback}
              />

              {blIsDriver && (
                <>
                  <div style={{ marginRight: '12px' }}>
                    <p className='text-primary fw-bold field'>
                      This household member must be added as a driver on your policy as he/she have a valid driver’s license but does not have their
                      own auto insurance.
                    </p>

                    <p className='text-primary fw-bold field'>
                      Please complete the following questions to complete your request. If you have any questions, please call 800-535-2873.
                    </p>
                  </div>

                  {/* Reside in state */}
                  <RadioButtonField
                    question={`Does this person currently reside in ${context?.userData?.state}*?`}
                    name={'resideInState'}
                    infoKey='addressInfo'
                    value={driverHHM?.addressInfo?.resideInState || ''}
                    setCallback={driverHHMCallback}
                  />

                  {/* Occupation */}
                  <TextField
                    label={"What is this person's occupation?*"}
                    infoKey='userInfo'
                    name={'occupation'}
                    value={driverHHM?.userInfo?.occupation || ""}
                    setCallback={driverHHMCallback}
                  />

                  {blUniversityAge && (
                    <>
                      <UniversityForm />
                    </>
                  )}
                  <hr />
                  {blIsMichigan && (
                    <RadioButtonField
                      question={`Has this person been convicted in the past 5 years of fraud or intent to defraud involving an insurance claim or an application for insurance; 
            Or has this person successfully been denied in the past 5 years, payment of a claim over $1,000.00 under an auto insurance policy, if there was evidence 
            or fraud or the intent to defraud involving an insurance claim or application?*`}
                      uw={true}
                      name={"convicted"}
                      infoKey='violationInfo'
                      value={driverHHM?.violationInfo?.convicted || ""}
                      setCallback={driverHHMCallback}
                    />
                  )}

                  {/* Military */}
                  <RadioButtonField
                    question={`Is the ${memberType} a member of any branch of military?*`}
                    uw={true}
                    name={'militaryMember'}
                    infoKey='userInfo'
                    value={driverHHM?.userInfo?.militaryMember || ''}
                    setCallback={driverHHMCallback}
                  />

                  {/* Disorders */}
                  <RadioButtonField
                    question={
                      `Does the ${memberType} have a disorder or condition that may impair their ability to safely operate a motor vehicle, including but not limited to Narcolepsy, Syncope, Blindness, or Seizures?*`
                    }
                    uw={true}
                    name={'disorders'}
                    infoKey='disabilityInfo'
                    value={driverHHM?.disabilityInfo?.disorders || ''}
                    setCallback={driverHHMCallback}
                  />

                  {/* Mental/Physical Impairments */}
                  <RadioButtonField
                    question={`Does this ${memberType} have any mental or physical impairments, other than those listed above, that would impair their ability to operate a motor vehicle safely (Not including prescription eyeglasses or contact lenses)?*`}
                    uw={true}
                    name={'physicalImpairments'}
                    infoKey='disabilityInfo'
                    value={driverHHM?.disabilityInfo?.physicalImpairments || ""}
                    setCallback={driverHHMCallback}
                  />

                  {/* Licensed under different name */}
                  <RadioButtonField
                    question={`Has this ${memberType} been licensed under a different name within the past 36 months?*`}
                    uw={true}
                    name={'diffNameLicensed'}
                    infoKey='driverInfo'
                    value={driverHHM?.driverInfo?.diffNameLicensed || ""}
                    setCallback={driverHHMCallback}
                  />

                  {driverHHM?.driverInfo?.diffNameLicensed === '1' && blIsMichigan && (
                    <div className='ms-3'>
                      {/* Previous Name */}
                      <TextField
                        label={'Previous Name*'}
                        name={'prevName'}
                        infoKey='driverInfo'
                        value={driverHHM?.driverInfo?.prevName}
                        setCallback={driverHHMCallback}
                      />

                      {/* Previous License Number */}
                      <TextField
                        label={'Previous License Number*'}
                        name={'prevNameLicenseNumber'}
                        infoKey='driverInfo'
                        value={driverHHM?.driverInfo?.prevNameLicenseNumber}
                        setCallback={driverHHMCallback}
                      />
                    </div>
                  )}

                  {/* Licensed under different state/country */}
                  <RadioButtonField
                    question={`Has this ${memberType} been licensed in another state or country within the past 36 months?*`}
                    uw={true}
                    name={'diffStateLicensed'}
                    infoKey='driverInfo'
                    value={driverHHM?.driverInfo?.diffStateLicensed || ""}
                    setCallback={driverHHMCallback}
                  />

                    {driverHHM?.driverInfo?.diffStateLicensed === '1' && blIsMichigan && (
                    <div className='ms-3'>
                      {/* Previous Name */}
                      <TextField
                        label={'Previous State/Country*'}
                        name={'prevState'}
                        infoKey='driverInfo'
                        value={driverHHM?.driverInfo?.prevState}
                        setCallback={driverHHMCallback}
                      />

                      {/* Previous License Number */}
                      <TextField
                        label={'Previous License Number*'}
                        name={'prevStateLicenseNumber'}
                        infoKey='driverInfo'
                        value={driverHHM?.driverInfo?.prevStateLicenseNumber}
                        setCallback={driverHHMCallback}
                      />
                    </div>
                  )}
                </>
              )}

              {
                !blIsDriver &&
                <>
                  {/* Licensed under different name */}
                  <RadioButtonField
                    question={`Has this ${memberType} been licensed under a different name within the past 36 months?*`}
                    uw={!blIsMichigan}
                    name={'diffNameLicensed'}
                    infoKey='driverInfo'
                    value={driverHHM?.driverInfo?.diffNameLicensed}
                    setCallback={driverHHMCallback}
                  />

                  {driverHHM?.driverInfo?.diffNameLicensed === '1' && blIsMichigan && (
                    <div className='ms-3'>
                      {/* Previous Name */}
                      <TextField
                        label={'Previous Name*'}
                        name={'prevName'}
                        infoKey='driverInfo'
                        value={driverHHM?.driverInfo?.prevName}
                        setCallback={driverHHMCallback}
                      />

                      {/* Previous License Number */}
                      <TextField
                        label={'Previous License Number*'}
                        name={'prevNameLicenseNumber'}
                        infoKey='driverInfo'
                        value={driverHHM?.driverInfo?.prevNameLicenseNumber}
                        setCallback={driverHHMCallback}
                      />
                    </div>
                  )}

                  {/* Licensed under different state/country */}
                  <RadioButtonField
                    question={`Has this ${memberType} been licensed in another state or country within the past 36 months?*`}
                    uw={!blIsMichigan}
                    name={'diffStateLicensed'}
                    infoKey='driverInfo'
                    value={driverHHM?.driverInfo?.diffStateLicensed}
                    setCallback={driverHHMCallback}
                  />

                  {driverHHM?.driverInfo?.diffStateLicensed === '1' && blIsMichigan && (
                    <div className='ms-3'>
                      {/* Previous Name */}
                      <TextField
                        label={'Previous State/Country*'}
                        name={'prevState'}
                        infoKey='driverInfo'
                        value={driverHHM?.driverInfo?.prevState}
                        setCallback={driverHHMCallback}
                      />

                      {/* Previous License Number */}
                      <TextField
                        label={'Previous License Number*'}
                        name={'prevStateLicenseNumber'}
                        infoKey='driverInfo'
                        value={driverHHM?.driverInfo?.prevStateLicenseNumber}
                        setCallback={driverHHMCallback}
                      />
                    </div>
                  )}

                </>
              }

              {/* Moving violations */}
              {(blIsDriver || blDriverAge) && (blIsNewJersey || blIsPennsylvania) &&
                <>
                  <RadioButtonField
                    question={`Has this ${memberType} received any Moving Violations and/or been in any Accidents or Claims in the last 36 months, regardless of fault?*`}
                    uw={!blIsMichigan}
                    name={'movingViolations'}
                    infoKey='violationInfo'
                    value={driverHHM?.violationInfo?.movingViolations || ""}
                    setCallback={driverHHMCallback}
                  />
                  <RadioButtonField
                    question={`Has this ${memberType}'s license been suspended or in a suspended status in the last 36 months?*`}
                    uw={!blIsMichigan}
                    name={'driverSuspended'}
                    infoKey='violationInfo'
                    value={driverHHM?.violationInfo?.driverSuspended || ""}
                    setCallback={driverHHMCallback}
                  />
                </>
              }
              {
                blIsMichigan && blIsDriver &&
                <div style={{ marginRight: '12px' }}>
                  <p className='text-primary fw-bold field'>
                    Has the {memberType} been convicted of, or has been subject to an order of disposition of the family division of circuit court for a violation
                    of any of the following, within the last 3 years:
                  </p>

                  <div className='ms-3'>
                    {/* Moving violation resulting in death/serious impairment */}
                    <RadioButtonField
                      question={
                        'a. Moving violation causing death or serious impairment of body function; or any other Michigan law for which a violation constitutes a felony resulting from the operation of a motor vehicle.*'
                      }
                      uw={true}
                      name={'seriousMovingViolations'}
                      infoKey='violationInfo'
                      value={driverHHM?.violationInfo?.seriousMovingViolations || ""}
                      setCallback={driverHHMCallback}
                    />

                    {/* Under influence */}
                    <RadioButtonField
                      question={'b. Operation of motor vehicle while under influence.*'}
                      uw={true}
                      name={'underInfluence'}
                      infoKey='violationInfo'
                      value={driverHHM?.violationInfo?.underInfluence ? driverHHM?.violationInfo?.underInfluence : ""}
                      setCallback={driverHHMCallback}
                    />

                    {/* Failure to stop resulting in serious impairment */}
                    <RadioButtonField
                      question={'c. Failure to stop when involved in an accident that results in serious impairment of a body function or death.*'}
                      uw={true}
                      name={'impairment'}
                      infoKey='violationInfo'
                      value={driverHHM?.violationInfo?.impairment || ""}
                      setCallback={driverHHMCallback}
                    />

                    {/* Failure to stop resulting in injury */}
                    <RadioButtonField
                      question={'d. Failure to stop when involved in an accident that results in injury to any individual.*'}
                      uw={true}
                      name={'ftsInjury'}
                      infoKey='violationInfo'
                      value={driverHHM?.violationInfo?.ftsInjury ? driverHHM?.violationInfo?.ftsInjury : ""}
                      setCallback={driverHHMCallback}
                    />

                    {/* Failure to stop resulting in vehicle damage */}
                    <RadioButtonField
                      question={
                        'e. Failure to stop when involved in an accident that results in damage to a vehicle operated by or attended by any individual.*'
                      }
                      uw={true}
                      name={'vehicleDamage'}
                      infoKey='violationInfo'
                      value={driverHHM?.violationInfo?.vehicleDamage ? driverHHM?.violationInfo?.vehicleDamage : ""}
                      setCallback={driverHHMCallback}
                    />

                    {/* Failure to provide required info */}
                    <RadioButtonField
                      question={'f. Failure to provide required information or to provide reasonable assistance to an injured individual.*'}
                      uw={true}
                      name={'provideInfoFailure'}
                      infoKey='violationInfo'
                      value={driverHHM?.violationInfo?.provideInfoFailure ? driverHHM?.violationInfo?.provideInfoFailure : ""}
                      setCallback={driverHHMCallback}
                    />

                    {/* Reckless driving */}
                    <RadioButtonField
                      question={'g. Reckless Driving, or a similar violation under the laws of any other state or municipality in or outside of Michigan.*'}
                      uw={true}
                      name={'recklessDriving'}
                      infoKey='violationInfo'
                      value={driverHHM?.violationInfo?.recklessDriving ? driverHHM?.violationInfo?.recklessDriving : ""}
                      setCallback={driverHHMCallback}
                    />
                  </div>
                </div>
              }

              {/* Moving violations (MICHIGAN ONLY) */}
              {blIsMichigan &&
                <RadioButtonField
                  question={`Has ${memberType} received any moving violations, or accidents and/or Claims, regardless of fault, in the last 36 months?*`}
                  uw={true}
                  name={'movingViolations'}
                  infoKey='violationInfo'
                  value={driverHHM?.violationInfo?.movingViolations || ''}
                  setCallback={driverHHMCallback}
                />
              }

              {/* Type of Health Insurance */}
              {blPipOption && blIsRelative && blHasInsurance && (
                <>
                  <SelectDropdown
                    label={`Please confirm what type of health insurance this ${memberType} has.*`}
                    name={'insuranceType'}
                    infoKey='driverInfo'
                    value={driverHHM?.driverInfo?.insuranceType}
                    dropdown={insuranceType}
                    setCallback={driverHHMCallback}
                  />
                </>
              )}
            </>

          </>
        )}


        {/* New Jersey/Pennsylvania */}
        {!blIsMichigan && (
          <>
            <hr />
            {/* Helpful Documents (New Jersey & Pennsylvania Only) */}
            {blIsNewJersey ? (
              <div className='text-center'>
                <HelpfulDocumentsNJ policyType={context?.userData?.policyType} />
              </div>
            ) : (
              <>
                <HelpfulDocumentsPA center='center' />
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AddHhmForm;

const UniversityForm = () => {
  const { driverHHM, driverHHMCallback } = useDriverHHM();

  return (
    <>
      {/* Enrolled in college/university */}
      <RadioButtonField
        question={'Driver enrolled in College/university?*'}
        infoKey='schoolInfo'
        name={'enrolledInCollege'}
        value={driverHHM?.schoolInfo?.enrolledInCollege || ''}
        setCallback={driverHHMCallback}
      />
      {driverHHM?.schoolInfo?.enrolledInCollege == '1' && (
        <>
          {/* School over 100 miles */}
          <RadioButtonField
            question={'Is school over 100 miles away from the policy address?*'}
            infoKey='schoolInfo'
            name={'school100Miles'}
            value={driverHHM?.schoolInfo?.school100Miles ? driverHHM?.schoolInfo?.school100Miles : ''}
            setCallback={driverHHMCallback}
          />

          {/* School Name */}
          <TextField
            label={'School Name*'}
            infoKey='schoolInfo'
            name={'schoolName'}
            value={driverHHM?.schoolInfo?.schoolName ? driverHHM?.schoolInfo?.schoolName : ""}
            setCallback={driverHHMCallback}
          />

          {/* School City */}
          <TextField
            label={'School City*'}
            infoKey='schoolInfo'
            name={'schoolCity'}
            value={driverHHM?.schoolInfo?.schoolCity ? driverHHM?.schoolInfo?.schoolCity : ""}
            setCallback={driverHHMCallback}
          />

          {/* School State */}
          <TextField
            label={'School State*'}
            infoKey='schoolInfo'
            name={'schoolState'}
            value={driverHHM?.schoolInfo?.schoolState ? driverHHM?.schoolInfo?.schoolState : ""}
            setCallback={driverHHMCallback}
          />
        </>
      )}
    </>
  );
};